export class Guides {
  constructor() {
    this.guides = document.createElement("div");
    this.guides.className = "guides wrap";
    this.guides.innerHTML = `
      <div class="inner grid">
        ${Array(12).fill('<div class="guides__guide"></div>').join("")}
      </div>
    `;

    document.body.appendChild(this.guides);

    // Show guides if they were enabled before
    if (localStorage.getItem("guides") === "true") {
      this.guides.style.visibility = "visible";
    }

    // Toggle guides with Ctrl+G
    document.addEventListener("keydown", (e) => {
      if (e.key === "g" && e.ctrlKey) {
        const visible = this.guides.style.visibility === "visible";
        this.guides.style.visibility = visible ? "hidden" : "visible";
        localStorage.setItem("guides", !visible);
      }
    });

    // Update window width display
    window.addEventListener("resize", () => {
      this.guides.dataset.windowWidth = window.innerWidth;
    });
  }
}